import { Injectable } from '@angular/core';
import { PhoneCountryCode } from '@banyan/commons/models/phone-country-code.model';
import { PhoneNumber, PhoneNumberUtil } from 'google-libphonenumber';

@Injectable()
export class PhoneNumberService {
  private readonly phoneNumberUtil: PhoneNumberUtil;

  constructor() {
    this.phoneNumberUtil = PhoneNumberUtil.getInstance();
  }

  parsePhoneNumber(_phoneNumber: string): PhoneNumber | null {
    try {
      return this.phoneNumberUtil.parseAndKeepRawInput(_phoneNumber);
    } catch (e) {
      return null;
    }
  }

  formatPhoneNumber(phoneCode: string, phone: string): string {
    return phoneCode.concat('', phone);
  }

  getFormattedRegions(): PhoneCountryCode[] {
    const countriesCode:PhoneCountryCode[] = [];
    const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });

    for (const regionCode of this.phoneNumberUtil.getSupportedRegions()) {
      const countryCode = this.phoneNumberUtil
        .getCountryCodeForRegion(regionCode)
        .toString();
      countriesCode.push({
        name: regionNames.of(regionCode) ?? '',
        code: '+' + countryCode,
      });
    }
    return countriesCode;
  }

  getIndonesiaFormatCode() {
    return '+' + this.phoneNumberUtil.getCountryCodeForRegion('ID').toString();
  }
}
